module.exports = __webpack_public_path__ + "static/media/camera-operator.dc7c488f.jpg";